module.exports = __webpack_public_path__ + "img/9.1744f97d.png";